/**
 * Dictionnaire de traduction des clés techniques vers labels français
 */
export const FIELD_LABELS: Record<string, string> = {
  // Client
  firstName: 'Prénom',
  lastName: 'Nom',
  customerName: 'Nom complet',
  email: 'Email',
  customerEmail: 'Email',
  phone: 'Téléphone',
  customerPhone: 'Téléphone',
  companyName: 'Entreprise',
  companyEmail: 'Email entreprise',
  companyPhone: 'Téléphone entreprise',
  companyWebsite: 'Site web',

  // Réservation
  roomName: 'Format choisi',
  spaceType: "Type d'espace",
  startDate: 'Date de début',
  endDate: 'Date de fin',
  startTime: 'Heure de début',
  endTime: 'Heure de fin',
  daysCount: 'Nombre de jours',
  durationType: 'Type de durée',
  participantCount: 'Nombre de participants',
  bookingReason: 'Motif de réservation',
  createdAt: 'Date de la réservation',

  // Options
  hasMealBreak: 'Pause repas',
  wantsMealBreak: 'Souhaite pause repas',
  hasCoffeeBreak: 'Pause café',
  wantsCoffeeBreak: 'Souhaite pause café',
  hasExternalCaterer: 'Traiteur externe',
  urgentQuote: 'Devis urgent',
  acceptedDisclaimer: 'Conditions acceptées',

  // Financier
  amount: 'Montant',
  totalAmount: 'Montant total',
  baseAmount: 'Montant de base',
  optionsAmount: 'Montant des options',
  label: 'Libellé',
  priceBreakdown: 'Détail des prix',

  // Métadonnées
  acceptedAt: 'Accepté le',
  updatedAt: 'Mis à jour le',
  status: 'Statut',
};

/**
 * Champs à masquer complètement (IDs techniques, métadonnées internes)
 */
export const HIDDEN_FIELDS = [
  'id',
  'userId',
  'bookingId',
  'applicationId',
  'equipmentIds',
  'capacityBracketId',
  'spaceId',
  'createdAt',
  'updatedAt',
  '__typename',
];

/**
 * Champs de type montant (pour formatage en devise)
 */
export const CURRENCY_FIELDS = ['amount', 'totalAmount', 'baseAmount', 'optionsAmount', 'price', 'cost'];

/**
 * Champs de type date (pour formatage français)
 */
export const DATE_FIELDS = ['startDate', 'endDate', 'acceptedAt', 'createdAt', 'updatedAt', 'date'];
